import React from 'react';
import { Card } from '../Card/Card';
import { KeyValueTable } from '../KeyValueTable/KeyValueTable';
import { t } from '../../locales/translate';
import { graphql } from '../../generated';
import { useSuspenseQuery } from '../../util/use_suspense_query';
import { withSuspendedCard } from '../../util/suspense';
import { useModalPresenter } from '../Modal/PresentedModal';
import { Icon } from '../Icon/Icon';
import { EditMetaModal } from './edit_meta_modal';

const GET_SHOP_META = graphql(`
  query GetShopMeta($id: ID!) {
    shop(id: $id) {
      id
      meta
      permissions {
        id
        update
      }
    }
  }
`);

const GET_CATEGORY_META = graphql(`
  query GetCategoryMeta($id: ID!) {
    category(id: $id) {
      id
      meta
      permissions {
        id
        update
      }
    }
  }
`);

const GET_PRODUCT_META = graphql(`
  query GetProductMeta($id: ID!) {
    product(id: $id) {
      id
      meta
      permissions {
        id
        update
      }
    }
  }
`);

const META_QUERIES = {
  shop: GET_SHOP_META,
  category: GET_CATEGORY_META,
  product: GET_PRODUCT_META,
} as const;

export type MetaContainingRecord = {
  id: string;
  meta?: string | JSONObject;
  permissions: {
    update: boolean;
  };
};

type Props = {
  id: string;
  type: 'product' | 'shop' | 'category';
};

function Meta$({ id, type }: Props): JSX.Element {
  const modal = useModalPresenter();

  const { data } = useSuspenseQuery(META_QUERIES[type], { variables: { id } });
  const item = data[type] as MetaContainingRecord;

  const metaObject = item.meta;

  return (
    <Card
      title={t.model[type].meta}
      actions={
        item.permissions.update && <Icon name="edit" onClick={() => modal.present(EditMetaModal, { id, type })}></Icon>
      }
    >
      <KeyValueTable
        fullWidth={false}
        items={Object.keys(metaObject).map((key) => ({
          key: key,
          value: JSON.stringify(metaObject[key]),
        }))}
      ></KeyValueTable>
    </Card>
  );
}

export const Meta = withSuspendedCard(Meta$, { loadingHeight: 400, loadingTitle: t.component.meta.card.title });
